import React from "react";
import { faBatteryThreeQuarters, faChargingStation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const getChargeIcon = (condition) => (
    <FontAwesomeIcon
        icon={condition && condition.charging ? faChargingStation : faBatteryThreeQuarters}
        className={condition && condition.charging ? "text-danger" : "text-success"}
    />
);

export default getChargeIcon;



// WEBPACK FOOTER //
// ./src/views/pages/bikes/helpers/get-charge-icon.js